<template>
  <div>
    <v-row class="pa-10">
      <v-col cols="12">
        <h2 class="primary--text font-weight-bold pt-5 pl-2">
          <v-icon color="primary" large left>
          </v-icon>
          {{ $t('display/offer:overview.title') }}
        </h2>

        <DataTablePaginated
          ref="table"
          class="ma-1"
          :headers="headers"
          icon="edit"
          icon2="picture_as_pdf"
          icon3="delete"
          @clickedButton1="editOffer"
          :iconTooltip="$t('buttons:edit')"
          @clickedButton2="generatedWindowPdf"
          :iconTooltip2="$t('display/offer:overview.dialog.pdf-title')"
          @clickedButton3="deleteOffer"
          :iconTooltip3="$t('buttons:delete')"
          @updateTableData="updateTable"
          @clickedAddButton="createCampaign"
          :addBtn="isAdmin"
          :addBtnText='$t("display/offer:overview.add-btn")'
          sortBy="createdAt"
          sort-desc
          @cacheCommit="$store.commit('display/elevator/storeElevatorOverviewSearch', $event)"
          :cachedSearch="$store.state.display.elevator.overviewSearch"
        />
      </v-col>
    </v-row>

    <TwoButtonDialog
      ref="deleteButton"
      :dialog-title="$t('dialog:delete-btn-title', {name : $t('common:media')})"
      :dialog-text="$t('dialog:delete-btn-dialog', {name : $t('common:media')})"
      :button1-text="$t('buttons:cancel')"
      :button2-text="$t('buttons:delete')"
      :hideButton="true"
      @clickedButton1="$refs.deleteButton.showDialog = false"
      @clickedButton2="finallyDelete"
    />

    <TwoButtonDialog
      ref="generatePdf"
      :dialog-title="$t('display/offer:overview.dialog.pdf-title')"
      :dialog-text="$t('display/offer:overview.dialog.pdf-text')"
      :button1-text="$t('buttons:cancel')"
      :button2-text="$t('display/offer:overview.dialog.send')"
      :hideButton="true"
      @clickedButton1="$refs.generatePdf.showDialog = false"
      @clickedButton2="generatedPdf"
    />

    <OfferForm
      ref="offerForm"
    />

    <CreateCampaign
      ref="createCampaign"
      @updateTable="$refs.table.callTableUpdate()"
    />
  </div>
</template>

<script>
import DataTablePaginated from '@/modules/core/components/DataTable/DataTablePaginated';
import TwoButtonDialog from '@/modules/core/components/TwoButtonDialog/TwoButtonDialog';
import CreateCampaign from '@/modules/display/views/offer/CreateCampaign';
import OfferService from '@/modules/display/services/offer-service';
import PdfService from '@/modules/display/services/pdf-service';
import OfferForm from "@/modules/display/views/offer/OfferForm";
import DataUtils from '@/modules/core/services/data-utils';
import Offer from "@/modules/display/data/offer";
import Utils from '@/modules/core/services/utils';

export default {
  name: "ElevatorOverview",
  components: {
    DataTablePaginated,
    CreateCampaign,
    TwoButtonDialog,
    OfferForm
  },
  data() {
    return {
      isAdmin: true,
      currentOffer: {}
    }
  },
  computed: {
    headers() {
      return [
        {text: this.$t('common:created_at'), value: 'createdAt'},
        {text: this.$t('common:customer'), value: 'customer.name'},
        {text: this.$t('display/offer:overview.agency'), value: 'name'},
        {text: this.$t('display/offer:overview.client'), value: 'client'},
        {text: this.$t('common:budget'), value: 'budget'},
        {text: this.$t('display/offer:overview.start'), value: 'dateStart'},
        {text: this.$t('display/offer:overview.end'), value: 'dateEnd'},
        {text: "", value: "controls", sortable: false}
      ];
    }

  },
  methods: {
    finallyDelete() {
      OfferService.deleteOffer(this.currentOffer,
        () => {
          this.$refs.deleteButton.showDialog = false;
          Utils.showSuccessSnackbar(this.$t('snackbar:delete-success', {name: this.$t('display/offer:overview.offer')}));
          this.$refs.table.callTableUpdate();
        },
        () => {
          Utils.showFailureSnackbar(this.$t('snackbar:delete-failure', {name: this.$t('display/offer:overview.offer')}));
        }
      );
    },
    deleteOffer(offer) {
      this.currentOffer = offer;
      this.$refs.deleteButton.showDialog = true;
    },
    generatedWindowPdf(offer) {
      this.currentOffer = offer;
      this.$refs.generatePdf.showDialog = true;
    },
    generatedPdf() {
      this.$refs.generatePdf.setButtonSettings(false, true, true, false);
      OfferService.sendPdfGenerationRequest(this.currentOffer.id,
        (response) => {
          let pdfId = response.data.pdfFileId;
          this.checkIfPdfGenerated(pdfId);
        },
        () => {
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('display/offer:overview.snackbar.pdf')}));
        }
      )
    },
    checkIfPdfGenerated(pdfDocumentId) {
      PdfService.sendPdfCheckStatusRequest(
        pdfDocumentId,
        (response) => {
          if (response.status == 202) {
            this.checkIfPdfGenerated(pdfDocumentId);
          } else {
            this.$refs.generatePdf.showDialog = false;
            this.$refs.generatePdf.setButtonSettings(false, false, false, false);
            this.downloadGeneratedPdf(pdfDocumentId);
          }
        },
        () => {
          this.$refs.generatePdf.showDialog = false;
          this.$refs.generatePdf.setButtonSettings(false, false, false, false);
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('display/offer:overview.snackbar.pdf')}));
        }
      )
    },
    downloadGeneratedPdf(pdfDocumentId) {
      PdfService.downloadPdf(
        pdfDocumentId,
        (pdfFile) => {
          const link = document.createElement('a');
          link.href = URL.createObjectURL(pdfFile);
          link.download = pdfDocumentId + '.pdf';
          link.click();
          URL.revokeObjectURL(link.href);
        }
      )
    },
    editOffer(offerItem) {
      this.$refs.offerForm.initialization(offerItem);
    },
    editOfferById(offerId) {
      this.$refs.offerForm.initializationById(offerId);
    },
    updateTable(options, search) {
      if (!search) search = '';

      this.$refs.table.loading = true;

      OfferService.readAllPaginatedFromAPI(
        options.page - 1,
        options.itemsPerPage,
        search,
        options.sortBy,
        options.sortDesc,
        (response) => {
          if (this.$refs.table !== undefined) {
            response.data.content = DataUtils.parseDataToObjectArray(response.data.content, Offer);
            this.$refs.table.fillTableData(response.data);
          }
          this.$refs.table.loading = false;
        },
        (error) => {
          this.$refs.table.loading = false;
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('display/offer:overview.offer')}));
          this.$logger.error(error);
        }
      );

    },
    createCampaign() {
      this.$refs.createCampaign.initialization();
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if(to.query.offer) {
        vm.editOfferById(to.query.offer)
        vm.$router.replace(`/${vm.$store.state.manager.displayModuleUrl}/offer`);
      }
    });
  },
}
</script>

<style scoped>

</style>
